// @ts-expect-error i18n
import i18nResourcesPrompt from '@alienfast/i18next-loader?include=**/reg_path/signup_to_download/survey/BaseQuestion.json!config/locales_i18next/index.js';
import styled from 'astroturf/react';
import addResources from 'js/i18next/addResources';
import useTranslationTest from 'js/utils/hooks/useTranslationTest';
import { ResearchInterestTagsInput } from 'js/videos/shared/research_interest_tags/ResearchInterestTagsInput';
import { ResearchInterest } from 'js/videos/shared/research_interest_tags/types';
import { useEffect } from 'react';
import { SurveyQuestion, SurveyQuestionPrompt } from './styles/QuestionStyles';
import { QuestionType, UserTaggingQuestion } from './types';
import _Subprompt from "RIQuestion-Subprompt.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/RIQuestion.tsx?styleId=Subprompt";


const PROMPT_TRANSLATION_NAMESPACE = 'RegPath.SignupToDownload.BaseQuestion';
addResources(i18nResourcesPrompt, PROMPT_TRANSLATION_NAMESPACE);

interface Props {
  question: UserTaggingQuestion & { questionType: QuestionType.RI };
  setQuestionLoadTime: () => void;
  maxAnswers?: number;
  selectedResearchInterests: Array<ResearchInterest>;
  onAdd(ri: ResearchInterest): void;
  onRemove(ri: ResearchInterest): void;
}

const Subprompt = /*#__PURE__*/styled("div", null, {
  displayName: "Subprompt",
  styles: _Subprompt
});

const RIQuestion: React.FC<Props> = ({
  question,
  setQuestionLoadTime,
  maxAnswers,
  ...riState
}) => {
  const { prompt, subprompt } = question;
  const [tPrompt] = useTranslationTest(PROMPT_TRANSLATION_NAMESPACE, true);
  useEffect(setQuestionLoadTime, [setQuestionLoadTime]);

  return (
    <SurveyQuestion>
      <SurveyQuestionPrompt>{tPrompt(prompt)}</SurveyQuestionPrompt>
      {subprompt && <Subprompt>{tPrompt(subprompt)}</Subprompt>}
      <ResearchInterestTagsInput
        maxResearchInterests={maxAnswers || 3}
        {...riState}
      />
    </SurveyQuestion>
  );
};

export default RIQuestion;
